<template>
  <ActionGradientComponent :style="{display: onlyFormBool ? 'none' : 'flex'}" />
  <div :class="style.contactBlock">
    <div :class="style.description">
      <h1 v-html="getHeader" />
      <p
        v-if="getParagraph"
        v-html="getParagraph"
        :class="style.descriptionParagraph"
      />
    </div>
    <FormComponent :answerInput="answerInput" :answer="answer" />
    <ButtonComponent
      :styleButton="{
        backgroundColor: isFormSend ? '#9F63FC!important' : '',
        width: '95%',
        height: '60px'
      }"
      :isErrorSendForm="isErrorSendForm"
      :isLastQuestionAndNotError="isLastQuestionAndNotError"
      :isLastQuestion="isLastQuestion"
      :isSuccessAndNotSend="isSuccessAndNotSend"
      :isFormSend="isFormSend"
      :withoutMargin="true"
      :fakeAfter="false"
      :isGreeting="false"
      :ifText="!isLastQuestion"
      :elseIfText="isSuccessAndNotSend"
      :alternativeText="textContactButton ?? nextButton"
      :text="'Далее'"
      v-if="handleClick"
      @click.prevent="handleClick($event, 'next')"
    />
    <span
      :class="style.underButtonText"
      v-text="quiz.textBellowButtonMobile"
      v-if="quiz?.textBellowButtonMobile"
    />
  </div>
</template>

<script lang="ts">
import FormComponent from "../../FormComponent/FormComponent.vue";
import ButtonSimple from "@/elements/buttonPurpleWhite/ButtonSimple.vue";
import style from "./ContactQuestion.module.scss";
import ActionGradientComponent from "../../ActionGradient/ActionGradientComponent.vue";
import ButtonComponent from "@/elements/buttonPurpleWhite/ButtonComponent.vue";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";
import {defineComponent} from "vue";
import {Quiz} from "@/page/quiz/typeQuiz";

export default defineComponent({
  name: "ContactQuestion",
  components: {
    ButtonComponent,
    ActionGradientComponent,
    ButtonSimple,
    FormComponent
  },
  props: {
    answerInput: Function,
    answer: Object,
    isFormSend: Boolean,
    isErrorSendForm: Boolean,
    isLastQuestionAndNotError: Boolean,
    isLastQuestion: Boolean,
    isSuccessAndNotSend: Boolean,
    handleClick: Function
  },
  data() {
    return {
      style,
      modifyQuiz
    };
  },
  computed: {
    quiz(): Quiz {
      return this.$quizStore.getQuiz;
    },
    getHeader() {
      const contactsQuestion = this.quiz.questions?.find(
        (question) => question?.type === "contacts"
      );
      return (
        contactsQuestion?.contacts?.headerMobile?.placeholder ||
        contactsQuestion?.contacts?.header ||
        "Готово, заполните форму ниже"
      );
    },
    getParagraph() {
      const contactsQuestion = this.quiz.questions?.find(
        (question) => question?.type === "contacts"
      );
      return (
        contactsQuestion?.contacts?.paragraphMobile?.placeholder ||
        contactsQuestion?.contacts?.paragraph ||
        ""
      );
    },
    onlyFormBool() {
      return this.modifyQuiz("get", "", ["onlyFormBool"]);
    },
    nextButton(): string {
      return this.modifyQuiz("get", "", ["nextButton"]) || "Рассчитать";
    },
    textContactButton(): string {
      return this.modifyQuiz("get", "", ["textContactButton"]) || "Рассчитать";
    }
  }
});
</script>
